<script>
  import * as yup from "yup";
  import { createEventDispatcher, onMount } from "svelte";
  import { account, appSession, appConstants } from "../stores/app.js";
  import MyModal from "../components/MyModal.svelte";
  import { navigate } from "svelte-routing";
  import RestActions from "../components/RestActions.svelte";

  let busy = false;
  const dispatch = createEventDispatcher();
  let restActions = null;
  let requestSent = false;

  let myModal;

  let form = {
    dirty: false,
    valid: true,
    submitted: false,

    data: {
      email: "",
    },

    schema: yup.object().shape({
      email: yup.string().lowercase().email({ message: "Invalid" }).required({ message: "Required" }),
    }),
    errors: null,
  };

  onMount(() => {
    M.updateTextFields();
  });

  function ValidateForm() {
    return new Promise(function (resolve, reject) {
      form.schema
        .validate(form.data, { abortEarly: false })
        .then((values) => {
          form.valid = true;
          form.errors = {};

          resolve(true);
        })
        .catch((validationErrors) => {
          form.valid = false;
          form.errors = {};

          for (let i = 0; i < validationErrors.inner.length; i++) {
            let error = validationErrors.inner[i];
            form.errors[error.path] = {
              type: error.type,
              message: typeof error.errors[0] == "object" ? error.errors[0].message : error.errors[0],
            };
          }
        });
    });
  }

  async function passwordResetRequest() {
    form.submitted = true;

    try {
      await ValidateForm(form);
      busy = true;
      await restActions.PasswordResetRequest("pilot", form.data.email);
      busy = false;
      requestSent = true;
    } catch (error) {
      busy = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, operatorId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          console.log(error);
          break;
      }
    }
  }

  function handleKeydown(event) {
    if (event.key == "Enter") passwordResetRequest();
  }
</script>

<style>
  .helper-text {
    margin-bottom: 30px;
  }
</style>

<div class="container">

  <div class="row">
    <div class="col s12 m8 offset-m2 l6 offset-l3 xl4 offset-xl4">

      <img
        src="assets/logo.png"
        style="display: block; max-width: 100%; height: auto; margin: 40px auto 40px auto;"
        alt="" />

      <h5 style="text-align: center; margin-bottom: 20px;">Password Reset</h5>
      {#if !requestSent}
        <p>Enter email address to reset password.</p>

        <div class="input-field" style="margin-top: 30px;">
          <input type="email" bind:value={form.data.email} />
          <label>Email</label>
          {#if form.errors && form.errors.email}
            <div class="helper-text red-text">{form.errors.email.message}</div>
          {/if}
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center;">

          <a href="#!" on:click={() => navigate('/')}>Cancel</a>

          <button
            class="btn right wave-effect blue-grey"
            on:click={() => {
              passwordResetRequest();
            }}
            disabled={busy}>
            Continue
          </button>
        </div>
      {:else}
        <p>
          An email message has been sent to your address {form.data.email} If you don't receive this message in your
          inbox then please check your junk/email folder.
        </p>

        <p>
          To reset your password please click the link contained within the message. You will then be prompted to enter
          a new password. Note, the link is valid for up to 60 minutes.
        </p>

        <p>
          <a
            href="#!"
            on:click={() => {
              navigate('/');
            }}>
            Return to sign-in
          </a>
        </p>
      {/if}

    </div>

    {#if busy}
      <div style="display: flex; justify-content: center; align-items: center; height: 50px; width: 100%;">
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-green-only">
            <div class="circle-clipper left">
              <div class="circle" />
            </div>
            <div class="gap-patch">
              <div class="circle" />
            </div>
            <div class="circle-clipper right">
              <div class="circle" />
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>

</div>

<MyModal bind:this={myModal} />

<svelte:window on:keydown={handleKeydown} />
<RestActions bind:this={restActions} />
